import { render, staticRenderFns } from "./InformeVentasEmpresario.vue?vue&type=template&id=20f2bd79"
import script from "./InformeVentasEmpresario.vue?vue&type=script&lang=js"
export * from "./InformeVentasEmpresario.vue?vue&type=script&lang=js"
import style0 from "./InformeVentasEmpresario.vue?vue&type=style&index=0&id=20f2bd79&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports